export default __webpack_public_path__ + "static/media/MARKTPLATZ_MITTELSTAND.ab61e078.png";